export const BASE_URL = 'files';

export const MAX_FILE_SIZE = 15000000;
